import { PortalContainer } from "./Portal"

export const LoadingScreeen = ({ text }: { text: string }) => {
    return (
        <PortalContainer visible={true}>
            <div id="loading-screen">
                <h1>{text}</h1>
            </div>
        </PortalContainer>
    )
}